export default "__VITE_ASSET__CK87vGBD__"